<template>
    <div class="left-menu-box">
        <el-col v-if="$isaccess">
            <el-menu
                :key="key"
                v-for="(item, key) in filterMaps"
                :default-active="activeHandle(item, key)"
                class="el-menu-vertical-demo"
                :collapse-transition="false"
                @open="handleOpen"
                @close="handleClose"
                @select="subMenuSelected"
            >
                <el-submenu class="el-menu-item-has-parent" :index="key" v-if="item.children">
                    <template slot="title">
                        <i :class="`left-menu-icon iconfont ${item.icon}`"></i>
                        <span v-html="item.title"></span>
                    </template>
                    <template v-for="(subItem, subkey) in item.children">
                        <el-menu-item
                            :key="subkey"
                            v-if="subItem.active === subkey"
                            class="el-menu-item-has-children"
                            :index="`${key}-${subItem.active}`"
                        >
                            <a :href="subItem.link + urlParams">
                                <i class="el-icon-custom el-icon-tickets"></i>
                                {{ subItem.title }}
                            </a>
                            <a :href="subItem.link + urlParams" target="_blank">
                                <i class="el-icon-plus"></i>
                            </a>
                        </el-menu-item>
                    </template>
                </el-submenu>
                <el-menu-item :index="key" v-else class="el-menu-item-no-children">
                    <a :href="item.link + urlParams">
                        <i :class="`left-menu-icon iconfont ${item.icon}`"></i>
                        <span v-html="item.title"></span>
                    </a>
                </el-menu-item>
            </el-menu>
        </el-col>
    </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import { forIn } from "lodash";
import qs from "qs";
export default {
    name: "sub-aside",
    data() {
        return {};
    },
    computed: {
        ...mapState([
            "$md5",
            "$base64",
            "$page",
            "$lodash",
            "$helper",
            "$route",
            "$routerMaps",
            "$projectType",
            "$isaccess",
            "$activeGameCode"
        ]),
        filterMaps() {
            let tmp = {};
            forIn(this.$routerMaps, (item, key) => {
                if (
                    key !== "system" &&
                    item.projectType === this.$projectType
                ) {
                    let obj = Object.assign({}, item, {
                        link: `/${item.url}?`.toLowerCase()
                    });
                    if (obj.children) {
                        let children = Object.assign({}, obj.children);
                        forIn(children, (child, ck) => {
                            children[
                                ck
                            ].link = `/${key}/${child.url}?`.toLowerCase();
                            if (child.jumpToRoute) {
                                children[
                                    ck
                                ].link = `/${child.jumpToRoute}.html?`.toLowerCase();
                            }
                        });
                        obj.children = children;
                    }

                    tmp[key] = obj;
                }
            });
            return tmp;
        },
        urlParams() {
            let tmp = this.getUrlParams();
            if(this.$page.indexOf('recharge') > -1) {
                let obj = {};
                obj.game_code = tmp.game_code;
                tmp = obj;
            }else{
                tmp = {
                    game_code: tmp.game_code
                }
            }
            return qs.stringify(
                Object.assign({}, tmp, {
                    game_code: this.$activeGameCode
                })
            );
        }
    },

    created() {},
    methods: {
        ...mapActions(["LOADING", "SAVE_VUE_OBJECT", "LOGOUT"]),
        getUrlParams() {
            let urlParams = window.location.search;
            if (urlParams) {
                urlParams = urlParams.substr(1);
                urlParams = qs.parse(urlParams);
            } else {
                urlParams = {};
            }
            return urlParams;
        },
        /**
         * 设置当前选择样式
         * @returns {string}
         */
        activeHandle() {
            let patharr = this.$page.split("/");

            if (patharr.length > 1) {
                let mune = this.$routerMaps[patharr[0]]["children"][patharr[1]];
                return `${patharr[0]}-${mune.active}`;
            } else {
                return this.$page;
            }
        },

        /**
         * 选择Menu页面跳转
         * @param key
         * @param keyPath
         */
        subMenuSelected(key, keyPath) {
            //console.log("--------->0",key, keyPath);
            //this.LOADING(true);
            /**无子节点菜单**/
            // if (keyPath.length === 1) {
            //     let menu = this.$routerMaps[keyPath];
            //     /**自定义路由跳转**/
            //     if (menu["jumpToRoute"]) {
            //         this.$route(menu["jumpToRoute"].toLocaleLowerCase());
            //     } else {
            //         this.$route(keyPath[0].toLocaleLowerCase());
            //     }
            //     return;
            // }
            // /**有子节点菜单**/
            // let arr = keyPath[1].split("-");
            // let menu = this.$routerMaps[arr[0]]["children"][arr[1]];
            // if (menu["jumpToRoute"]) {
            //     this.$route(menu["jumpToRoute"].toLocaleLowerCase());
            // } else {
            //     this.$route(arr.join("/").toLocaleLowerCase());
            // }
        },
        handleOpen(key, keyPath) {
            console.log(key, keyPath);
        },
        handleClose(key, keyPath) {
            console.log(key, keyPath);
        }
    }
};
</script>

<style lang="scss">
.left-menu-box {
    .left-menu-icon {
        font-size: 20px;
        margin-right: 10px;
    }

    .el-submenu {
        background: #eff9ff;
        border-top: 1px solid #dbf1ff;
        border-bottom: 1px solid #f2f7fb;
        font-size: 14px;
    }
    .el-menu-item-has-parent {
        .el-menu--inline {
            padding: 1px 0;
        }
    }

    .el-submenu .el-submenu__title {
        color: #333;
        padding: 0 15px !important;
    }

    .el-menu-item-no-children {
        display: flex;
        padding-left: 15px !important;
        background: #eff9ff;
        border-top: 1px solid #dbf1ff;
        border-bottom: 1px solid #f2f7fb;
        font-size: 14px;
        a {
            color: #333;
            text-decoration: none;
        }
    }

    .el-menu-item.is-active {
        background: #eff9ff;
        color: rgb(22, 155, 213);
    }

    .el-menu-item.el-menu-item-has-children {
        display: flex;
        font-size: 13px;
        padding-left: 30px !important;
        padding-right: 10px;
        margin: 1px 0;
        a {
            color: #333;
            text-decoration: none;
            &:first-child {
                flex: 1;
            }
            &:last-child {
                padding: 0 5px;
                i {
                    margin-right: 0;
                    font-size: 14px;
                }
                &:hover i {
                    font-weight: bold;
                    color: darken($color: #409eff, $amount: 10%);
                }
            }
        }
    }

    .el-submenu .el-submenu__title:hover,
    .el-menu-item-no-children:hover,
    .el-menu-item-no-children.is-active,
    .el-submenu.is-active .el-submenu__title {
        background: #d9ecff;
    }

    .el-menu-item-has-children.is-active {
        color: rgb(22, 155, 213);
        background: #d9ecff;
        font-weight: bold;
    }

    .el-menu-item .el-icon-custom {
        font-size: 16px;
    }
}
</style>



// WEBPACK FOOTER //
// website/subComponents/aside.vue